import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import carImg from "../../../assets/images/car.png";
// import redMapPin from "../../../assets/images/red-map-pin.png";

const OrdersInfoModalMap = ({ record }) => {
  const [windowHeight, setWindowHeight] = useState(150);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      const headerHeight = document.querySelector("header").offsetHeight;
      const footerHeight = document.querySelector("footer").offsetHeight;

      setWindowHeight(window.innerHeight - headerHeight - footerHeight - 16);

      setLoading(false);
    };
    window.setTimeout(handleResize, 1000);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customIcon = L.icon({
    // iconUrl: redMapPin,
    iconUrl: carImg,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    popupAnchor: [0, -20],
  });

  return loading ? (
    <div className="orders-info-map-loading">Зареждане...</div>
  ) : (
    !loading && (
      <MapContainer
        center={[
          record[0].geocoding?.closeBillLatitude,
          record[0].geocoding?.closeBillLongitude,
        ]}
        zoom={13}
        maxZoom={16}
        minZoom={10}
        style={{ height: `${windowHeight}px` }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker
          position={[
            record[0].geocoding?.closeBillLatitude,
            record[0].geocoding?.closeBillLongitude,
          ]}
          icon={customIcon}
        >
          <Popup>Закриване на сметка</Popup>
        </Marker>

        <Marker
          position={[
            record[0].geocoding?.orderLatitude,
            record[0].geocoding?.orderLongitude,
          ]}
        >
          <Popup>Адрес на доставка</Popup>
        </Marker>
      </MapContainer>
    )
  );
};

export default OrdersInfoModalMap;
